import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, ClipboardList, Store, Users, Activity, LogOut } from "lucide-react";

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const Item = ({ to, icon: Icon, label, testid }) => {
    const active = loc.pathname === to;
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
          active ? "bg-amber text-cream" : "text-cream/80 hover:bg-light-ink"
        }`}
      >
        <Icon className="w-4 h-4" strokeWidth={1.6} />
        {label}
      </Link>
    );
  };

  return (
    <div className="min-h-screen flex bg-white text-ink">
      <aside className="w-60 bg-ink min-h-screen p-5 flex flex-col gap-2 sticky top-0" data-testid="admin-sidebar">
        <div className="mb-6">
          <div className="font-serif text-2xl text-cream">Tablo</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-amber-soft">Super Admin</div>
        </div>
        <Item to="/admin" icon={LayoutDashboard} label="Ops Dashboard" testid="admin-nav-ops" />
        <Item to="/admin/bookings" icon={ClipboardList} label="Bookings" testid="admin-nav-bookings" />
        <Item to="/admin/restaurants" icon={Store} label="Restaurants" testid="admin-nav-restaurants" />
        <Item to="/admin/users" icon={Users} label="Users" testid="admin-nav-users" />
        <Item to="/admin/audit" icon={Activity} label="Audit log" testid="admin-nav-audit" />
        <div className="mt-auto pt-6 border-t border-light-ink">
          <div className="text-xs text-cream/60 mb-2">{user?.name || user?.phone}</div>
          <button
            onClick={() => { logout(); nav("/admin/login"); }}
            className="text-xs text-cream/80 hover:text-cream flex items-center gap-1"
            data-testid="admin-logout-btn"
          >
            <LogOut className="w-3.5 h-3.5" strokeWidth={1.6} /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 p-8 overflow-y-auto">{children}</main>
    </div>
  );
}
